<template>
<transition name="fade">
    <div class="side-nav-overlay js-side-nav animated" v-if="showNav" @click.self="$emit('close-nav')">
        <nav class="side-nav">
            <button class="close" @click="$emit('close-nav')">
                <img src="@/assets/img/menu-to-close-2.svg" class="menu-to-close-2">
            </button>
            <ul class="side-nav-list">
                <li>
                    <a href="#about" @click.prevent="$emit('close-nav-scroll', '#about')">About us</a>
                </li>
                <li>
                    <a href="#brands" @click.prevent="$emit('close-nav-scroll', '#brands')">Brands</a>
                </li>
                <li>
                    <a href="#contact" @click.prevent="$emit('close-nav-scroll', '#contact')">Contact us</a>
                </li>
            </ul>
        </nav>
    </div>
</transition>
</template>

<script>
export default {
    props: ['showNav']
}
</script>

<style lang="scss">
.side-nav-overlay {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.side-nav {
  position: absolute;
  right: 0px;
  top: 0px;
  width: 320px;
  height: 100%;
  padding: 30px;
  padding-top: 150px;
  box-shadow: -10px 16px 32px 0 rgba(0, 0, 0, 0.16);
  background: #fff;
}
.side-nav-list {
  a {
    font-weight: 600;
    font-size: 2em;
  }
}
.close {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
}
</style>
